// //////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
// //////////////////////////////////////////////////////////////////////////////////
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_MODAL = 'SHOW_MODAL'

export const modalNames = {
	form: 'form',
}

// //////////////////////////////////////////////////////////////////////////////////
// ACTIONS
// //////////////////////////////////////////////////////////////////////////////////
export function showModal(payload) {
	return {
		type: SHOW_MODAL,
		payload,
	}
}

export function hideModal(payload) {
	return {
		type: HIDE_MODAL,
		payload,
	}
}

// //////////////////////////////////////////////////////////////////////////////////
// REDUCER
// //////////////////////////////////////////////////////////////////////////////////

export default function reducer(state = {}, action) {
	switch (action.type) {
		case HIDE_MODAL:
			return Object.assign({}, state, { [action.payload.name]: { show: false } })
		case SHOW_MODAL:
			return Object.assign({}, state, {
				[action.payload.name]: Object.assign({}, action.payload, { show: true }),
			})
		default:
			return state
	}
}
